import { getRouteApi, Link } from "@tanstack/react-router"
import { Button } from "@workspace/web-ui/components/button"


const COLORS = {
    TEXT_PRIMARY: '#2D2F35',
    TEXT_SECONDARY: '#667085',
} as const

interface PatientCardProps {
    patientName: string
    programEnrollment: string
    patientEmail?: string
    requestDate: string
    currentWeight: string
    patientId: string
}


const PatientLogCard = ({ title, description }: { title: string, description: string }) => (
    <div className="flex flex-col gap-2 min-w-0">
        <h2 style={{ color: COLORS.TEXT_PRIMARY }} className="text-xs font-normal uppercase">{title}</h2>
        <p style={{ color: COLORS.TEXT_PRIMARY }} className="text-sm font-medium truncate" title={description}>{description}</p>
    </div>
)




export const PatientCard = ({ patientName, patientEmail, requestDate, patientId }: PatientCardProps) => {
    const routeApi = getRouteApi("/(dashboard)/dashboard/$program");
    const { program } = routeApi.useParams();
    return (
        <div className="flex flex-col gap-3 w-full p-4 rounded-[8px] bg-[#F1F4F9]">
            <h2 className="text-base font-medium">Patient Information</h2>
            {/* PATIENT LOG */}
            <div className="grid grid-cols-3 gap-4 w-full">
                {/* {patientName && !patientEmail && (
                    )} */}
                {/* {patientEmail && ( */}
                {patientEmail ? (
                    <PatientLogCard title="Patient Email" description={patientEmail ?? ""} />
                ) : (
                    <PatientLogCard title="Patient Name" description={patientName} />
                )}
                {/* )} */}
                <PatientLogCard title="Request Date" description={requestDate} />
                <PatientLogCard title="Medication Type" description={"Medication refill"} />
                {/* <div className="flex flex-col gap-2">
                   <PatientLogCard title="Weight" description={currentWeight} />
                   <PatientLogCard title="Program Enrollment" description={programEnrollment} />
                   </div> */}
            </div>

            <Button asChild className="button-primary w-full bg-[#FFFFFF] border border-[#DCDCDE] !text-md !font-medium !px-[24px] !py-3">
                <Link
                    to="/dashboard/$program/patients/patient/$id"
                    params={{ id: patientId, program }}
                    data-testid="patient-card-link"
                    search={{ name: patientName.replace(/\s+/g, ""), sessionId: "" }}
                    className="w-full"
                >
                    Go to Patient Log
                </Link>
            </Button>
        </div>
    )
}
